import Vue from "vue";
import Vuex from "vuex";
//  modules
import global from "./modules/global";
import header from "./modules/header";
import batchOperation from "./modules/batch-operation";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    header,
    batchOperation
  }
});